import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-222d7820"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "pb-1" }, "Resource Assignments", -1))
const _hoisted_5 = { "aria-hidden": "true" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_7 = { class: "resourceAssignHeaderDetails shadow-sm rounded" }
const _hoisted_8 = { class: "headerLH" }
const _hoisted_9 = { class: "card-title" }
const _hoisted_10 = { class: "headerLH" }
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { class: "card-title txtWrap" }
const _hoisted_13 = { class: "headerLH" }
const _hoisted_14 = { "aria-hidden": "true" }
const _hoisted_15 = { class: "font-weight-bold" }
const _hoisted_16 = { class: "headerLH" }
const _hoisted_17 = { "aria-hidden": "true" }
const _hoisted_18 = { class: "font-weight-bold" }
const _hoisted_19 = { class: "font-weight-bold" }
const _hoisted_20 = {
  id: "actionable",
  class: "panleBody scrollBar"
}
const _hoisted_21 = {
  key: 0,
  id: "actionable-assignment-header"
}
const _hoisted_22 = {
  key: 1,
  id: "tList"
}
const _hoisted_23 = { "aria-hidden": "true" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Click to view Help Videos", -1))
const _hoisted_25 = { style: {"background-color":"rgb(202, 202, 202)"} }
const _hoisted_26 = {
  key: 2,
  id: "actionable-assignment-tabs",
  class: "mt-3 border rounded tabHeight"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Home Department ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Other Department", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Unscheduled Staff", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Staff Search", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Staffing Matrix", -1))
const _hoisted_32 = {
  key: 0,
  id: "sms-notification-tab-count",
  class: "badge bg-danger ms-1"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Contract Labor", -1))
const _hoisted_34 = {
  class: "panelTabData scrollBar",
  id: "home",
  role: "tabpanel",
  "aria-labelledby": "home-tab"
}
const _hoisted_35 = {
  key: 0,
  class: "panelTabData scrollBar",
  id: "other",
  role: "tabpanel",
  "aria-labelledby": "other-tab"
}
const _hoisted_36 = {
  key: 1,
  class: "panelTabData scrollBar",
  id: "unscheduled",
  role: "tabpanel",
  "aria-labelledby": "unscheduled-tab"
}
const _hoisted_37 = {
  key: 2,
  class: "panelTabData scrollBar",
  id: "search",
  role: "tabpanel",
  "aria-labelledby": "search-tab"
}
const _hoisted_38 = {
  key: 3,
  class: "panelTabData scrollBar",
  id: "staffing",
  role: "tabpanel",
  "aria-labelledby": "staffing-tab"
}
const _hoisted_39 = {
  key: 4,
  class: "panelTabData scrollBar",
  id: "smsNotifications",
  role: "tabpanel",
  "aria-labelledby": "sms-notification-tab"
}
const _hoisted_40 = {
  key: 5,
  class: "panelTabData scrollBar",
  id: "contractlabor",
  role: "tabpanel",
  "aria-labelledby": "contractlabor-tab"
}
const _hoisted_41 = {
  key: 3,
  id: "assignment-container"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { key: 3 }
const _hoisted_46 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_neu_col = _resolveComponent("neu-col")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_row = _resolveComponent("neu-row")!
  const _component_DepartmentSummaryHeader = _resolveComponent("DepartmentSummaryHeader")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_item = _resolveComponent("neu-item")!
  const _component_neu_list = _resolveComponent("neu-list")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_HomeDepartment = _resolveComponent("HomeDepartment")!
  const _component_OtherDepartment = _resolveComponent("OtherDepartment")!
  const _component_UnscheduledStaff = _resolveComponent("UnscheduledStaff")!
  const _component_StaffSearch = _resolveComponent("StaffSearch")!
  const _component_StaffingMatrix = _resolveComponent("StaffingMatrix")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_ContractLabor = _resolveComponent("ContractLabor")!
  const _component_Assignment = _resolveComponent("Assignment")!
  const _component_PlusMetricsListPopup = _resolveComponent("PlusMetricsListPopup")!
  const _component_DepartmentSummaryNote = _resolveComponent("DepartmentSummaryNote")!
  const _component_ClockInStatus = _resolveComponent("ClockInStatus")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_SendSMSPopup = _resolveComponent("SendSMSPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createVNode(_component_neu_row, { class: "resourceAssignHeading" }, {
          default: _withCtx(() => [
            _createVNode(_component_neu_col, {
              class: "neu-text-left",
              md: "9",
              cols: "12"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_neu_col, {
              class: "pr-6",
              md: "3",
              cols: "12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: "#",
                  class: "closeBtn neu-tooltip",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [
                  _createElementVNode("i", _hoisted_5, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'close'],
                      size: "lg"
                    })
                  ]),
                  _hoisted_6
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_neu_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_neu_col, {
                md: "6",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h5", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, " (" + _toDisplayString(_ctx.FacilityCoid) + ")" + _toDisplayString(_ctx.FacilityName), 1)
                  ]),
                  _createElementVNode("h6", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.ClusterName), 1),
                    _createTextVNode(" > "),
                    _createElementVNode("span", _hoisted_12, " (" + _toDisplayString(_ctx.DepartmentCode) + ")" + _toDisplayString(_ctx.DepartmentName), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_neu_col, {
                md: "6",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h6", _hoisted_13, [
                    _createElementVNode("i", _hoisted_14, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['far', 'calendar'],
                        size: "sm"
                      })
                    ]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.StartDate), 1)
                  ]),
                  _createElementVNode("h6", _hoisted_16, [
                    _createElementVNode("i", _hoisted_17, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: ['far', 'clock'],
                        size: "sm"
                      })
                    ]),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.StartTime), 1),
                    _createTextVNode(" -"),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.EndTime), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_ctx.isdeptSummaryHeaderVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_DepartmentSummaryHeader, { deptSummaryHeaderData: _ctx.deptSummaryHeaderData }, null, 8, ["deptSummaryHeaderData"])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isAssignmentSectionVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_neu_row, {
                noGutters: "",
                slot: "beginning"
              }, {
                default: _withCtx(() => [
                  (_ctx.profileData.TrainingEnabled)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        class: "modaltoolbarIcon neu-tooltip",
                        style: {"cursor":"pointer","color":"#3673AA","left":"50px","text-align":"left"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayTrainingList($event)))
                      }, [
                        _createElementVNode("span", _hoisted_23, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'fa-video'],
                            size: "lg"
                          }),
                          _createTextVNode(" Learn How ")
                        ]),
                        _hoisted_24
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.isTrainingVideoListVisible)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => {_ctx.isTrainingVideoListVisible=false;}),
                    class: "modalTutorialList z-max",
                    ref: "trainingActionableVideoList",
                    id: "trainingActionableVideoList",
                    style: _normalizeStyle([{"{ top":"mousePosY+'px' }"}, { left: _ctx.mousePosX+'px' , border:'solid', 'border-color':'#3673AA' }])
                  }, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_neu_list, {
                        color: "white",
                        lines: "none",
                        style: {"background-color":"white"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_item, { class: "training-video-list" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_label, {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openVideo('https://mediaconnect.app.medcity.net/embed?id=7b5ec633-e6ee-476c-a41f-6e2c1f24227f')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Add an Assignment")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_neu_item, { class: "training-video-list" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_neu_label, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openVideo('https://mediaconnect.app.medcity.net/embed?id=625c5df2-5938-4e3d-924c-c5f0e402c834')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Tabs in the Resource Assignment Screen")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ], 36))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.isAssignmentSectionVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_neu_tablist, {
                value: _ctx.selectedTab,
                class: "mx-4 tabList neu-text-left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "home-tab",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSelectedTab('home-tab')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_27
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "other-tab",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSelectedTab('other-tab')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "unscheduled-tab",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setSelectedTab('unscheduled-tab')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "search-tab",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setSelectedTab('search-tab')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_30
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "staffing-tab",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setSelectedTab('staffing-tab')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "sms-notification-tab",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setSelectedTab('sms-notification-tab'))),
                    tooltip: "tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createTextVNode(" Notifications "),
                        (_ctx.isShowNotifictionBadge == true && _ctx.notificationCount > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.notificationCount), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.allowManualClRequests)
                    ? (_openBlock(), _createBlock(_component_neu_tab, {
                        key: 0,
                        white: "",
                        tab: "contractlabor-tab",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setSelectedTab('contractlabor-tab')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["value"]),
              _withDirectives(_createElementVNode("div", _hoisted_34, [
                _createVNode(_component_HomeDepartment, { homeTabInput: _ctx.actionableConfig }, null, 8, ["homeTabInput"])
              ], 512), [
                [_vShow, _ctx.isHomeTabVisible]
              ]),
              (_ctx.isOtherTabVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createVNode(_component_OtherDepartment, { otherTabInput: _ctx.actionableConfig }, null, 8, ["otherTabInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isUnscheduledTabVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createVNode(_component_UnscheduledStaff, { unschStaffTabInput: _ctx.actionableConfig }, null, 8, ["unschStaffTabInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isSearchTabVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_component_StaffSearch, { staffingSerachTabInput: _ctx.actionableConfig }, null, 8, ["staffingSerachTabInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isStaffingTabVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createVNode(_component_StaffingMatrix, { staffingGridTabInput: _ctx.actionableConfig }, null, 8, ["staffingGridTabInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isNotificationsTabVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createVNode(_component_Notifications, { notificationTabInput: _ctx.actionableConfig }, null, 8, ["notificationTabInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isContractLaborTabVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createVNode(_component_ContractLabor, { contractLaborTabInput: _ctx.actionableConfig }, null, 8, ["contractLaborTabInput"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_neu_row, { slot: "end" })
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAssignmentSectionVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createVNode(_component_Assignment, {
                assignmentInput: _ctx.assignmentInput,
                assignmentType: _ctx.assignmentType
              }, null, 8, ["assignmentInput", "assignmentType"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isMetricsViewListVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
          _createVNode(_component_PlusMetricsListPopup, {
            plusMetrics: _ctx.plusMetrics,
            onCloseModal: _ctx.closePopup
          }, null, 8, ["plusMetrics", "onCloseModal"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowDepartmentSummaryNote)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createVNode(_component_DepartmentSummaryNote, {
            onCloseModal: _ctx.closeNotePopup,
            noteInput: _ctx.actionableConfig
          }, null, 8, ["onCloseModal", "noteInput"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isShowClockInDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createVNode(_component_ClockInStatus, {
            onCloseModal: _ctx.closeClockInStatusPopup,
            clockInInput: _ctx.clockStatusModel
          }, null, 8, ["onCloseModal", "clockInInput"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSendSMSPopupVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createVNode(_component_SendSMSPopup, {
            smsInput: _ctx.smsInput,
            onCloseModal: _ctx.closeSendSMSPopup
          }, null, 8, ["smsInput", "onCloseModal"])
        ]))
      : _createCommentVNode("", true)
  ]))
}